const state = {
  listaMotivosRestricoesArquivo: [],
  listaArquivos: [],
  listaPecas: [],
  listaDocumentos: [],
  listaArquivosAssinadosNaoVinculados: [],
  arquivo: null,
  arquivoBlobURL: null,
  arquivoEdicaoDialog: false,
  cancelamentoPecaDialog: false,
  adicionarArquivoAssinadoDialog: false,
  informacoesPecasUploadDialog: false,
  passoAtual: 1,
  situacaoVinculo: {},
  documentoSelecionado: {},
  justificativaCancelamento: undefined
}

export default state
